import React from 'react';
import { Button } from 'antd-mobile';
import { JsBridge, messageMethodIsSupport } from '@/utils/JsBridge';
import { compareVersion, getAppVersionFromUserAgent, getUserAgent, isApp } from '@/utils/EnvUtils';
import './BookingAppUpgradeNotice.css';

export const MIN_BOOKING_APP_VERSION = '3.25.0';

function getDownloadModel() {
  return /iPhone|iPad|iPod/i.test(getUserAgent()) ? 'ios' : 'android';
}

export function isBookingAppUpgradeRequired(): boolean {
  if (!isApp()) {
    return false;
  }

  const appVersion = getAppVersionFromUserAgent();
  if (!appVersion) {
    return false;
  }

  return !compareVersion(appVersion, MIN_BOOKING_APP_VERSION);
}

export function openQiluAppUpgrade(): void {
  if (messageMethodIsSupport('updateAppVersion')) {
    JsBridge.updateAppVersion(JSON.stringify({
      sourceFrom: 'booking-platform',
    }));
    return;
  }

  window.location.href = `https://api.deerbook.cn/v1/app/download?model=${getDownloadModel()}`;
}

const BookingAppUpgradeNotice: React.FC = () => {
  const appVersion = getAppVersionFromUserAgent();

  return (
    <div className="booking-app-upgrade-page">
      <div className="booking-app-upgrade-card">
        <div className="booking-app-upgrade-badge">需要升级奇鹿 App</div>
        <h1>当前版本暂不支持 1v1 外教功能</h1>
        <p>
          请升级到 {MIN_BOOKING_APP_VERSION} 及以上版本后再进入。升级后可从奇鹿首页 Banner 或 1v1 外教入口继续使用。
        </p>
        {appVersion && (
          <div className="booking-app-upgrade-version">
            当前版本：{appVersion}
          </div>
        )}
        <Button
          block
          color="primary"
          shape="rounded"
          className="booking-app-upgrade-action"
          onClick={openQiluAppUpgrade}
        >
          立即升级
        </Button>
        <div className="booking-app-upgrade-tip">
          如未自动跳转，可在应用市场搜索“奇鹿”更新 App。
        </div>
      </div>
    </div>
  );
};

export default BookingAppUpgradeNotice;
